import React, { Component } from "react";
import { Element, scroller } from "react-scroll";
import MessageItem from "./MessageItem";
import MessageInput from "./MessageInput";
import Firebase from "../../../firebasehelper";
import { getStringfromSeconds } from "../../../functions";
var timer;

class MessageList extends Component {
  state = {
    showInput: false,
    messages: [],
    name: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      admin_typing: false,
      brand_typing: false,
    };
  }

  componentDidMount() {
    let { ticket, brand } = this.props;
    const { id: brand_id, name: brand_name } = brand;
    const { id: ticket_id, type, time, signup } = ticket;

    let time_str = getStringfromSeconds(time);

    Firebase.getSupportChat(brand_id, ticket_id, (res) => {
      let chats = Object.values(res);
      if (!signup)
        chats.unshift({
          message: `${brand_name} has requested support with <b>${type}</b> on ${time_str}.`,
          type: "brand",
          username: "Bot",
        });
      this.setState({ messages: chats });
    });
    Firebase.getAdminTyping(brand_id, ticket_id, (typing) => {
      this.setState({ admin_typing: typing });
    });
    this.scrollToBottom();
  }
  componentWillReceiveProps(nextProps) {
    let { ticket, brand } = nextProps;
    const { id: brand_id, name: brand_name } = brand;
    const { id: ticket_id, type, time, signup } = ticket;

    let time_str = getStringfromSeconds(time);
    Firebase.getSupportChat(brand_id, ticket_id, (res) => {
      let chats = Object.values(res);
      if (!signup)
        chats.unshift({
          message: `${brand_name} has requested support with <b>${type}</b> on ${time_str}.`,
          type: "brand",
          username: "Bot",
        });
      this.setState({ messages: chats });
    });
    Firebase.getAdminTyping(brand_id, ticket_id, (typing) => {
      this.setState({ admin_typing: typing });
    });
    this.scrollToBottom();
  }
  scrollToBottom(delay = 0) {
    scroller.scrollTo("bottom", {
      duration: 200,
      delay: 0,
      smooth: "easeInOutQuart",
      containerId: "containerElement",
    });
  }

  setMessages() {
    const { icon } = this.props;
    const { messages } = this.state;
    setTimeout(() => this.scrollToBottom(), 100);
    return messages.map((message, i) => {
      return (
        <MessageItem message={message} key={i} icon={icon} loaded={true} />
      );
    });
  }

  setMessageInState(message) {
    const messages = this.state.messages.slice();
    messages.push(message);
    this.setState({ messages });
  }

  addMessage = (message) => {
    const { brand, ticket } = this.props;
    const { id: ticket_id } = ticket;
    const { id: brand_id } = brand;
    this.setMessageInState(message);
    Firebase.addSupportMessage(brand_id, ticket_id, message, (res) => {
      Firebase.setBrandSupportUnReadMessage(brand_id, ticket_id, {
        latest: message.message,
        time: Date.now(),
        ticket: ticket,
      });
    });
    setTimeout(() => this.scrollToBottom(), 100);
  };
  onType = () => {
    const { brand, ticket } = this.props;
    const { id: ticket_id } = ticket;
    const { id: brand_id } = brand;
    Firebase.setBrandTypeValue(brand_id, ticket_id, true);
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      Firebase.setBrandTypeValue(brand_id, ticket_id, false);
    }, 1000);
  };

  render() {
    const { admin_typing } = this.state;
    const { username } = this.props;
    return (
      <div className="message-list-wrapper-container">
        <div className="message-list-wrapper">
          <Element className="message-items-container" id="containerElement">
            {this.setMessages()}
            {admin_typing && (
              <MessageItem message={{ type: "admin" }} loaded={false} />
            )}
            <Element name="bottom"></Element>
          </Element>
          <div
            component="div"
            className="message-input-container"
            ref={(el) => {
              this.messagesEnd = el;
            }}
          >
            <MessageInput
              addMessage={this.addMessage}
              onType={this.onType}
              username={username}
              type="brand"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MessageList;



// WEBPACK FOOTER //
// ./src/screens/AdminSupport/LiveChat/MessageList.js